<template>
  <div>
    <div class="mb-2">
      <b-form-file
        v-model="file"
        :state="
          Boolean(file) &&
          file &&
          ((file.size <= max_file_size && restrict_file_weight) ||
            !restrict_file_weight)
        "
        aria-describedby="input-file-feedback"
        :placeholder="$t('reusable.fileSelector.selectFileOrDrag')"
        :browse-text="$t('reusable.fileSelector.browse')"
      >
        <!-- <template slot="file-name" slot-scope="{ names }">
          <b-badge variant="primary">{{ names[0] }}</b-badge>
          <b-badge v-if="names.length > 1" variant="primary" class="ml-1">
            + {{ names.length - 1 }} More files
          </b-badge>
        </template> -->
      </b-form-file>
      <span
        v-if="!(file && file.size > max_file_size && restrict_file_weight)"
        class="ml-1"
        style="font-size: 12px"
      >
        {{
          $t("reusable.fileSelector.fileSizeExceeded", {
            maxSize: $max_size_in_files
              ? $max_size_in_files.max_size_text
              : "6MB",
          })
        }}
      </span>
      <b-form-invalid-feedback id="input-file-feedback">
        <span v-if="file && file.size > max_file_size && restrict_file_weight">
          {{
            $t("reusable.fileSelector.fileSizeExceeded", {
              maxSize: $max_size_in_files
                ? $max_size_in_files.max_size_text
                : "6MB",
            })
          }}
        </span></b-form-invalid-feedback
      >
      <div v-if="url" class="file-div">
        <!-- <b-img :src="url" fluid alt="file"></b-img> -->
      </div>
      <div class="buttons-div">
        <b-button
          v-if="url && !upload_file"
          :disabled="file && file.size > max_file_size && restrict_file_weight"
          @click="save"
          class="mt-2"
          >{{ $t("reusable.common.save") }}</b-button
        >
        <b-button v-else-if="url && upload_file" :disabled="true" class="mt-2">
          {{ $t("reusable.fileSelector.saving") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";
import { toast, showLoadingAlert } from "@/utils/utils";

export default {
  name: "FileSelector",
  props: {
    // Attachments: {
    //   type: [Array, Number],
    //   required: true,
    // },
    post_file: {
      type: Boolean,
      default: true,
    },
    restrict_file_weight: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file: null,
      url: null,
      data: null,
      upload_file: false,
      // Al cambiar el max_file_size asegurar modificar "El archivo no puede superar de tamaño"
      max_file_size: this.$max_size_in_files
        ? this.$max_size_in_files.max_size
        : 12582912,
    };
  },
  computed: {
    ...mapGetters({
      files: names.FILES,
    }),
  },
  methods: {
    save() {
      if (
        this.file &&
        ((this.file.size <= this.max_file_size && this.restrict_file_weight) ||
          !this.restrict_file_weight)
      ) {
        const formData = new FormData();
        formData.append("file", this.file);
        if (this.post_file) {
          this.upload_file = true;
          showLoadingAlert(
            this.$t("reusable.fileSelector.uploadingFile"),
            this.$t("reusable.fileSelector.pleaseWaitUpload")
          );
          this.$store
            .dispatch(names.POST_FILE, formData)
            .then((response) => {
              toast(this.$t("reusable.fileSelector.fileSaved"));
              this.upload_file = false;
              this.$emit("created", response);
              this.$swal.close();
            })
            .catch(() => {
              this.$swal.close();
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.fileSelector.problemUploadingFile"),
                "error"
              );
            });
        } else this.$emit("file", formData);
      }
    },
  },
  watch: {
    file() {
      this.url = URL.createObjectURL(this.file);
    },
  },
};
</script>

<style scoped>
.file-div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-self: center;
  justify-items: center;
  width: 100%;
}
/* img {
  max-width: 200px;
  max-height: 200px;
} */
.buttons-div {
  text-align: right;
}
</style>